import { get } from 'lodash';
import { createPropsSelectorOrm } from '../utils';

export const getDriverData = createPropsSelectorOrm((session, driverId) =>
  get(session.Driver.withId(driverId), 'ref')
);
